//New flip counter

// Set the date we're counting down to
var countDownDate = new Date('Oct 15, 2019 08:00:00').getTime(2019, 10, 15);

//---------------------------------break------------------------//

// burger menu //
const burger = document.querySelector('.burger');
const activeMenu = document.querySelector('.navbar');
const links = document.querySelectorAll('.navbar li');

burger.addEventListener('click', e => {
  activeMenu.classList.toggle('open');
});

links.forEach(link => {
  link.addEventListener('click', e => {
    activeMenu.classList.remove('open');
  });
});

// Time settings:
var countDownDate = new Date('Oct 15, 2019 23:59:59').getTime(2019, 10, 15);

var x = setInterval(function() {
  var now = new Date().getTime();
  var distance = countDownDate - now;
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  document.getElementById('day').innerHTML = days;
  document.getElementById('hours').innerHTML = hours;
  document.getElementById('minutes').innerHTML = minutes;
  document.getElementById('sec').innerHTML = seconds;

  // days + 'day ' + hours + 'h ' + minutes + 'm ' + seconds + 's ';

  if (distance < 0) {
    clearInterval(x);
    document.getElementById('demo').innerHTML = 'EXPIRED!';
  }
}, 1000);

var ifr = document.getElementById('JotFormIFrame-91895033551359');
if (window.location.href && window.location.href.indexOf('?') > -1) {
  var get = window.location.href.substr(window.location.href.indexOf('?') + 1);
  if (ifr && get.length > 0) {
    var src = ifr.src;
    src = src.indexOf('?') > -1 ? src + '&' + get : src + '?' + get;
    ifr.src = src;
  }
}
window.handleIFrameMessage = function(e) {
  if (typeof e.data === 'object') {
    return;
  }
  var args = e.data.split(':');
  if (args.length > 2) {
    iframe = document.getElementById('JotFormIFrame-' + args[args.length - 1]);
  } else {
    iframe = document.getElementById('JotFormIFrame');
  }
  if (!iframe) {
    return;
  }
  switch (args[0]) {
    case 'scrollIntoView':
      iframe.scrollIntoView();
      break;
    case 'setHeight':
      iframe.style.height = args[1] + 'px';
      break;
    case 'collapseErrorPage':
      if (iframe.clientHeight > window.innerHeight) {
        iframe.style.height = window.innerHeight + 'px';
      }
      break;
    case 'reloadPage':
      window.location.reload();
      break;
    case 'loadScript':
      var src = args[1];
      if (args.length > 3) {
        src = args[1] + ':' + args[2];
      }
      var script = document.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      document.body.appendChild(script);
      break;
    case 'exitFullscreen':
      if (window.document.exitFullscreen) window.document.exitFullscreen();
      else if (window.document.mozCancelFullScreen)
        window.document.mozCancelFullScreen();
      else if (window.document.mozCancelFullscreen)
        window.document.mozCancelFullScreen();
      else if (window.document.webkitExitFullscreen)
        window.document.webkitExitFullscreen();
      else if (window.document.msExitFullscreen)
        window.document.msExitFullscreen();
      break;
  }
  var isJotForm = e.origin.indexOf('jotform') > -1 ? true : false;
  if (
    isJotForm &&
    'contentWindow' in iframe &&
    'postMessage' in iframe.contentWindow
  ) {
    var urls = {
      docurl: encodeURIComponent(document.URL),
      referrer: encodeURIComponent(document.referrer)
    };
    iframe.contentWindow.postMessage(
      JSON.stringify({ type: 'urls', value: urls }),
      '*'
    );
  }
};
if (window.addEventListener) {
  window.addEventListener('message', handleIFrameMessage, false);
} else if (window.attachEvent) {
  window.attachEvent('onmessage', handleIFrameMessage);
}

var ifr = document.getElementById('JotFormIFrame-91902144622350');
if (window.location.href && window.location.href.indexOf('?') > -1) {
  var get = window.location.href.substr(window.location.href.indexOf('?') + 1);
  if (ifr && get.length > 0) {
    var src = ifr.src;
    src = src.indexOf('?') > -1 ? src + '&' + get : src + '?' + get;
    ifr.src = src;
  }
}
window.handleIFrameMessage = function(e) {
  if (typeof e.data === 'object') {
    return;
  }
  var args = e.data.split(':');
  if (args.length > 2) {
    iframe = document.getElementById('JotFormIFrame-' + args[args.length - 1]);
  } else {
    iframe = document.getElementById('JotFormIFrame');
  }
  if (!iframe) {
    return;
  }
  switch (args[0]) {
    case 'scrollIntoView':
      iframe.scrollIntoView();
      break;
    case 'setHeight':
      iframe.style.height = args[1] + 'px';
      break;
    case 'collapseErrorPage':
      if (iframe.clientHeight > window.innerHeight) {
        iframe.style.height = window.innerHeight + 'px';
      }
      break;
    case 'reloadPage':
      window.location.reload();
      break;
    case 'loadScript':
      var src = args[1];
      if (args.length > 3) {
        src = args[1] + ':' + args[2];
      }
      var script = document.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      document.body.appendChild(script);
      break;
    case 'exitFullscreen':
      if (window.document.exitFullscreen) window.document.exitFullscreen();
      else if (window.document.mozCancelFullScreen)
        window.document.mozCancelFullScreen();
      else if (window.document.mozCancelFullscreen)
        window.document.mozCancelFullScreen();
      else if (window.document.webkitExitFullscreen)
        window.document.webkitExitFullscreen();
      else if (window.document.msExitFullscreen)
        window.document.msExitFullscreen();
      break;
  }
  var isJotForm = e.origin.indexOf('jotform') > -1 ? true : false;
  if (
    isJotForm &&
    'contentWindow' in iframe &&
    'postMessage' in iframe.contentWindow
  ) {
    var urls = {
      docurl: encodeURIComponent(document.URL),
      referrer: encodeURIComponent(document.referrer)
    };
    iframe.contentWindow.postMessage(
      JSON.stringify({ type: 'urls', value: urls }),
      '*'
    );
  }
};
if (window.addEventListener) {
  window.addEventListener('message', handleIFrameMessage, false);
} else if (window.attachEvent) {
  window.attachEvent('onmessage', handleIFrameMessage);
}

var ifr = document.getElementById('JotFormIFrame-91903322709355');
if (window.location.href && window.location.href.indexOf('?') > -1) {
  var get = window.location.href.substr(window.location.href.indexOf('?') + 1);
  if (ifr && get.length > 0) {
    var src = ifr.src;
    src = src.indexOf('?') > -1 ? src + '&' + get : src + '?' + get;
    ifr.src = src;
  }
}
window.handleIFrameMessage = function(e) {
  if (typeof e.data === 'object') {
    return;
  }
  var args = e.data.split(':');
  if (args.length > 2) {
    iframe = document.getElementById('JotFormIFrame-' + args[args.length - 1]);
  } else {
    iframe = document.getElementById('JotFormIFrame');
  }
  if (!iframe) {
    return;
  }
  switch (args[0]) {
    case 'scrollIntoView':
      iframe.scrollIntoView();
      break;
    case 'setHeight':
      iframe.style.height = args[1] + 'px';
      break;
    case 'collapseErrorPage':
      if (iframe.clientHeight > window.innerHeight) {
        iframe.style.height = window.innerHeight + 'px';
      }
      break;
    case 'reloadPage':
      window.location.reload();
      break;
    case 'loadScript':
      var src = args[1];
      if (args.length > 3) {
        src = args[1] + ':' + args[2];
      }
      var script = document.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      document.body.appendChild(script);
      break;
    case 'exitFullscreen':
      if (window.document.exitFullscreen) window.document.exitFullscreen();
      else if (window.document.mozCancelFullScreen)
        window.document.mozCancelFullScreen();
      else if (window.document.mozCancelFullscreen)
        window.document.mozCancelFullScreen();
      else if (window.document.webkitExitFullscreen)
        window.document.webkitExitFullscreen();
      else if (window.document.msExitFullscreen)
        window.document.msExitFullscreen();
      break;
  }
  var isJotForm = e.origin.indexOf('jotform') > -1 ? true : false;
  if (
    isJotForm &&
    'contentWindow' in iframe &&
    'postMessage' in iframe.contentWindow
  ) {
    var urls = {
      docurl: encodeURIComponent(document.URL),
      referrer: encodeURIComponent(document.referrer)
    };
    iframe.contentWindow.postMessage(
      JSON.stringify({ type: 'urls', value: urls }),
      '*'
    );
  }
};
if (window.addEventListener) {
  window.addEventListener('message', handleIFrameMessage, false);
} else if (window.attachEvent) {
  window.attachEvent('onmessage', handleIFrameMessage);
}

function smoothControll(target, duration) {
  var target = document.querySelector(target);
  var targetPosition = target.getBoundingClientRect().top;
  var startPosition = window.pageYOffset;
  var distance = targetPosition - startPosition;
  var startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    var timeElapsed = currentTime - startTime;
    var run = ease();
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animation);
}
